// ✅ Correct way in React
import { useState, useEffect } from "react";

function ContactUs() {
  

  return (
    <div>
      {/* Banner Section */}
      <div className="page-banner-area">
        <h2>Sample Page</h2>
        <p>Get in Touch with Us</p>
      </div>
                  <div className="about-us-main-wrap">
              <div className="container">
                      <div className="about-usleft-content">
                         <h2>Complete Cybersecurity Protection for Your Business</h2>
                         <p>At Pranasrishti Solutions, we deliver end-to-end cybersecurity solutions designed to safeguard every part of your digital ecosystem. Our approach goes far beyond traditional protection, combining cutting-edge technology, industry best practices, and expert intelligence to keep your organization safe from evolving cyber threats.
                          Whether you’re a growing startup, mid-sized business, or large enterprise, our solutions are built to scale with your needs. From data protection and network security to application defense and compliance management, we ensure your business is resilient against even the most sophisticated attacks.<br/>
                          With us, you get:
                          </p>
                      </div>
                    </div>
                 </div>
      {/* Contact Us Main Wrap */}
    </div>
  );
}

export default ContactUs;
